import Marquee from "react-fast-marquee";

const words = ["Concierge", "Butler", "Turndown Gifts", "Priority Dining", "Sunbed Reservations", "Golf 50% Off", "Spa Sanctuary", "Anniversary Rituals"];

export default function EditorialMarquee() {
  return (
    <section className="bg-[#E6C5C0] border-y border-black/5 py-8 md:py-10 relative z-[2]" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {words.concat(words).map((w, i) => (
          <span key={i} className="marquee-item">
            <span className="font-serif-editorial italic text-2xl md:text-4xl text-[#1A1A1A]">{w}</span>
            <span className="w-2 h-2 rounded-full bg-[#C5A059]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
